import { useAuth } from 'context/auth/auth'
import { useEffect } from 'react'
import { TOKEN_KEY } from 'Constants'
import { useHistory } from 'react-router-dom'

export const AccessAuthGuardProvider = ({ children }) => {
  const { authTokens } = useAuth()
  const history = useHistory()

  useEffect(() => {
    const tokenFromLocalStorage = JSON.parse(localStorage.getItem(TOKEN_KEY))
    if (!authTokens && !tokenFromLocalStorage) {
      history.push('/login')
    }
  }, [authTokens, history])

  return children
}
